<template>
  <div class="opening-cell-renderer" v-if="params">
    <el-button
        v-if="params.data.entityType === 'account' || params.data.entityType === 'sub-account'"
        size="mini"
        @click="openAccountTransactionModal(params)">
      {{params.data.openingamount ? formatPrice(params.data.openingamount) : formatPrice(0)}}
    </el-button>
    <el-button
        v-if="params.data.entityType === 'group'"
        size="mini">
      <!-- {{formatPrice(groupSum(params))}} -->
      {{params.data.openingamount ? formatPrice(params.data.openingamount) : formatPrice(0)}}
    </el-button>
    <el-button
        v-if="params.data.entityType === 'folder'"
        size="mini">
      <!-- {{formatPrice(groupSum(params))}} -->
      {{params.data.openingamount ? formatPrice(params.data.openingamount) : formatPrice(0)}}
    </el-button>
  </div>
</template>

<script>
export default {
  name: "openingCellRenderer",
  methods: {
    openAccountTransactionModal(params) {
      this.params.context.componentParent.openAccountTransactionModal(params)
    },
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    groupSum(params){
      return params.value ? this.params.value : 0
    }
  }
}
</script>

<style lang="less" scoped>
  .opening-cell-renderer {
    width:100%;
    padding:0 5px;
    button {
      width: 100%;
      text-align: right;
      display:flex;
      justify-content: flex-end;
    }
  }
</style>
